import { Breadcrumbs } from '@snack-uikit/breadcrumbs';
import { FileSVG } from '@snack-uikit/icons';
import { Typography } from '@snack-uikit/typography';

import { LinkWrapper } from '@/components/static';
import { SOURCE_PLATFORM_QUERY_PARAM_NAME } from '@/constant/routes';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { CategoryDataItem } from '@/types/serp';
import { addQueryParamToString } from '@/utils/navigation';
import { getItemBreadcrumbs } from '@/utils/serp';

import s from './styles.module.scss';

export function SearchItem({ article }: { article: CategoryDataItem }) {
  const currentPlatform = useCurrentPlatform();

  return (
    <div className={s.search_item}>
      <FileSVG />

      <div className={s.search_item_content}>
        <LinkWrapper link={addQueryParamToString(article.link, SOURCE_PLATFORM_QUERY_PARAM_NAME, currentPlatform)}>
          <Typography.LightTitleM tag='h1' className={s.searched_article_title}>
            <span dangerouslySetInnerHTML={{ __html: article.title }} />
          </Typography.LightTitleM>
        </LinkWrapper>
        <Typography.SansBodyM className={s.searched_article_text}>
          <span dangerouslySetInnerHTML={{ __html: `${article.description}...` }} />
        </Typography.SansBodyM>
        <Breadcrumbs size='xs' separator='/' items={getItemBreadcrumbs(article)} />
      </div>
    </div>
  );
}
